import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../assets/css/mobile.css";

const Mobile = () => {
  return (
    <Container>
      <div className="page-content contact pt-3">
        <Row className="align-items-center">
          {/* Sol Kolon - Promosyon Görseli */}
          <Col lg={3} md={12} className="mb-4">
      
          <img src={require("../assets/mobile-left.jpeg")} style={{width: "100%", height: "100%"}} alt="Mobil Uygulamamız" />
          </Col>

          {/* Sağ Kolon - Açıklama Metni ve QR Kodlar */}
          <Col lg={9} md={12}>
            <div className="mobile-description">
              <div className="description-text">
                <p>
                  <strong>Türk Dünyası Ansiklopedisi</strong>, Atatürk Araştırma Merkezi tarafından hazırlanmış olup 31 Aralık 2024 tarihinde hayata geçirilmiştir. 
                  Uygulama, Türk devletleri, tarihi şahsiyetler, kültür, sanat ve edebiyat gibi geniş bir yelpazede kapsamlı içerik sunmaktadır.
                </p>
                <p>
                  Kullanıcı dostu arayüzü ile gündüz/gece modu, favoriler listesi, makale geçmişi ve metin içi bağlantılar gibi özellikler sunan uygulama, 
                  iOS ve Android platformlarında ücretsiz ve reklamsız olarak kullanıma sunulmuştur. Türk Dünyası'nın ortak değerlerini gelecek nesillere aktarmayı hedeflemektedir.
                </p>
                <p>
                  Tanıtım videosuna <a href="https://www.youtube.com/shorts/G544QRpcSq0" target="_blank" className="video-link">buradan</a> erişim sağlayabilirsiniz.
                </p>
              </div>
              
              <div className="url-section">
                <h5>URL adresleri:</h5>
                <p><strong>iOS için:</strong> <a href="https://apps.apple.com/tr/app/t%C3%BCrk-d%C3%BCnyas%C4%B1-ansiklopedisi/id6746564883?l=tr" target="_blank" rel="noopener noreferrer">https://apps.apple.com/tr/app/t%C3%BCrk-d%C3%BCnyas%C4%B1-ansiklopedisi/id6746564883?l=tr</a></p>
                <p><strong>Android için:</strong> <a href="https://play.google.com/store/apps/details?id=com.ayk.turkdunyasiansiklopedisi" target="_blank" rel="noopener noreferrer">https://play.google.com/store/apps/details?id=com.ayk.turkdunyasiansiklopedisi</a></p>
              </div>
              
              <div className="qr-codes">
                <div className="qr-code-item">
                  <div className="qr-code">
                    <img src={require("../assets/android.jpeg")} alt="Android QR Code" />
                  </div>
                  <h6 className="qr-title">Play Store</h6>
                </div>
                <div className="qr-code-item">
                  <div className="qr-code">
                    <img src={require("../assets/ios.jpeg")} alt="Apple QR Code" />
                  </div>
                  <h6 className="qr-title">Apple Store</h6>
                </div>
              </div>
            </div>
          </Col>
        </Row>
    
      </div>
    </Container>
  );
};

export default Mobile;
